export enum PolicyType {
  Policies = 0,
  PrivacyPolicies = 1,
  ExchangePolicies = 2,
  CookiesPolicies = 3,
  Faq = 4
};
